(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbb-article-pro"]) return;
  try {
    
  if (!customElements.get('bbb-reading-guide')) {
    customElements.define('bbb-reading-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const body = this.querySelector('.bbb-reading__body');
        if (!body) return;
        body.querySelectorAll('table').forEach((table, index) => {
          if (table.parentElement.classList.contains('bbb-reading__table')) return;
          const region = document.createElement('div');
          region.className = 'bbb-reading__table';
          region.setAttribute('role', 'region');
          region.setAttribute('aria-label', table.caption?.textContent.trim() || `${this.dataset.tableLabel} ${index + 1}`);
          region.tabIndex = 0;
          table.before(region);
          region.append(table);
        });
        const aside = this.querySelector('.bbb-reading__aside');
        if (!aside) return;
        let headings = [...body.querySelectorAll('h2')].filter(h => h.textContent.trim());
        if (!headings.length) headings = [...body.querySelectorAll('h3')].filter(h => h.textContent.trim());
        if (headings.length < 3) return;
        const list = aside.querySelector('ol');
        list.replaceChildren();
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let id = `${this.id}-chapter-${index + 1}`;
            while (document.getElementById(id)) id += '-chapter';
            heading.id = id;
          }
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(heading.id)}`;
          link.textContent = heading.textContent.trim();
          link.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            if (!matchMedia('(min-width: 990px)').matches) aside.querySelector('details').open = false;
            requestAnimationFrame(() => {
              const hadTabindex = heading.hasAttribute('tabindex');
              if (!hadTabindex) heading.tabIndex = -1;
              heading.focus({ preventScroll: true });
              heading.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
              if (!hadTabindex) heading.addEventListener('blur', () => heading.removeAttribute('tabindex'), { once: true, signal });
            });
          }, { signal });
          li.append(link);
          list.append(li);
        });
        aside.hidden = false;
        this.querySelector('.bbb-reading__layout').classList.add('bbb-reading__layout--toc');
        const screen = matchMedia('(min-width: 990px)');
        const update = () => { aside.querySelector('details').open = screen.matches; };
        screen.addEventListener('change', update, { signal });
        update();
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbb-merker"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-merker-grid]');
    const cards = Array.from(grid.querySelectorAll('[data-merker-card]'));
    const collator = new Intl.Collator('nb', { sensitivity: 'base', numeric: true });
    cards.sort((a, b) => collator.compare(a.dataset.name, b.dataset.name)).forEach(card => grid.append(card));
    const search = root.querySelector('[data-merker-search]');
    const alphabet = root.querySelector('[data-merker-alphabet]');
    const count = root.querySelector('[data-merker-count]');
    const reset = root.querySelector('[data-merker-reset]');
    const normalize = s => s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('nb').replace(/&/g, 'and').replace(/[^a-z0-9æø]/g, '');
    const firstLetter = s => { const c = s.trim().toLocaleUpperCase('nb').charAt(0); return /^[A-ZÆØÅ]$/.test(c) ? c : '#'; };
    const letters = Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ');
    if (cards.some(card => firstLetter(card.dataset.name) === '#')) letters.unshift('#');
    for (const letter of letters) {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.letter = letter; button.textContent = letter;
      button.setAttribute('aria-pressed', 'false');
      button.disabled = !cards.some(card => firstLetter(card.dataset.name) === letter);
      alphabet.append(button);
    }
    let selected = 'all';
    function update() {
      const query = normalize(search.value); let visible = 0;
      for (const card of cards) {
        const text = normalize(card.dataset.name + ' ' + card.dataset.vendor);
        const match = text.includes(query) && (selected === 'all' || firstLetter(card.dataset.name) === selected);
        card.hidden = !match; if (match) visible++;
      }
      count.textContent = visible + ' ' + root.dataset.countLabel;
      root.querySelector('[data-merker-empty]').hidden = visible !== 0;
      reset.hidden = !query && selected === 'all';
      alphabet.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.letter === selected)));
    }
    alphabet.addEventListener('click', event => { const b = event.target.closest('button[data-letter]'); if (!b || b.disabled) return; selected = b.dataset.letter; search.value = ''; update(); });
    search.addEventListener('input', () => { selected = 'all'; update(); });
    reset.addEventListener('click', () => { search.value = ''; selected = 'all'; update(); search.focus(); });
    root.querySelector('[data-merker-tools]').hidden = false; update();
  }
  document.querySelectorAll('[data-bbb-merker]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bbb-merker]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbb-related-articles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bbb-article-carousel')) {
    customElements.define(
      'bbb-article-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.bbb-guides__track');
          if (!this.track) return;

          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          const controls = this.querySelector('.bbb-guides__controls');
          const buttons = [...controls.querySelectorAll('button')];

          const update = () => {
            const max = this.track.scrollWidth - this.track.clientWidth;

            controls.hidden = max < 2;
            buttons[0].disabled = this.track.scrollLeft <= 2;
            buttons[1].disabled = this.track.scrollLeft >= max - 2;
          };

          buttons.forEach(button => {
            button.addEventListener(
              'click',
              () => {
                const card = this.track.firstElementChild;
                const gap =
                  parseFloat(getComputedStyle(this.track).columnGap) || 0;
                const distance = card.getBoundingClientRect().width + gap;

                this.track.scrollBy({
                  left: Number(button.dataset.direction) * distance,
                  behavior: matchMedia(
                    '(prefers-reduced-motion: reduce)'
                  ).matches
                    ? 'auto'
                    : 'smooth'
                });
              },
              options
            );
          });

          this.track.addEventListener('scroll', update, {
            ...options,
            passive: true
          });

          this.observer = new ResizeObserver(update);
          this.observer.observe(this.track);
          update();
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
